// React component to embed a simplified and clarified flowchart SVG for SweatText

import React from 'react';

const ReminderSystemFlowchart = ({ width = '100%', height = 'auto' }) => (<img src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/icons/ptc/how_sweattext_works_03.png"
  alt="How SweatText Works Flowchart"
  style={{ width, height, maxWidth: '1000px', margin: '2rem auto', display: 'block', borderRadius: '8px', boxShadow: '0 0 15px rgba(0,0,0,0.1)' }} />
   



  // <div style={{ maxWidth: '1000px', margin: '2rem auto' }}>
  //   <svg
  //     viewBox="0 0 1000 600"
  //     width={width}
  //     height={height}
  //     xmlns="http://www.w3.org/2000/svg"
  //     style={{ background: 'white', borderRadius: '8px', boxShadow: '0 0 15px rgba(0,0,0,0.1)' }}
  //   >
  //     <text x="500" y="50" textAnchor="middle" fontSize="36" fontWeight="bold" fill="#1a237e">How SweatText Works</text>
  //     <text x="500" y="90" textAnchor="middle" fontSize="20" fill="#5c6bc0">From Trainer Setup to Client Impact</text>

  //     {/* <!-- Setup Column --> */}
  //     <rect x="60" y="140" width="260" height="180" rx="10" fill="#e3f2fd" />
  //     <text x="190" y="165" textAnchor="middle" fontWeight="bold" fontSize="16">Trainer Setup</text>
  //     <text x="80" y="200" fontSize="14">
  //       🔒 Secure Login
  //     </text>
  //     <text x="100" y="215" fontSize="12">
  //       Sign in using email or Google
  //     </text>
  //     <text x="80" y="230" fontSize="14">
  //       👤 Add Clients
  //     </text>
  //     <text x="100" y="245" fontSize="12">
  //       Import or enter with phone #
  //     </text>
  //     <text x="80" y="260" fontSize="14">
  //       📆 Schedule Reminders — Choose session times
  //     </text>
  //     <text x="80" y="290" fontSize="14">
  //       ✏️ Customize Messages — Write the reminder text
  //     </text>

  //     {/* <!-- System Automation --> */}
  //     <rect x="380" y="180" width="240" height="100" rx="10" fill="#f3e5f5" />
  //     <text x="500" y="205" textAnchor="middle" fontWeight="bold" fontSize="16">SweatText System</text>
  //     <text x="400" y="235" fontSize="14">📤 Automatically sends a custom SMS</text>
  //     <text x="400" y="260" fontSize="14">⏱️ Reminder arrives 1 hour before session</text>

  //     {/* <!-- Client Value --> */}
  //     <rect x="680" y="140" width="260" height="180" rx="10" fill="#fff3e0" />
  //     <text x="810" y="165" textAnchor="middle" fontWeight="bold" fontSize="16">Client Benefits</text>
  //     <text x="700" y="200" fontSize="14">📱 Gets a clear SMS reminder on time</text>
  //     <text x="700" y="230" fontSize="14">🚫 No login or app required</text>
  //     <text x="700" y="260" fontSize="14">🤝 Feels supported by their trainer</text>
  //     <text x="700" y="290" fontSize="14">✅ Shows up on time, ready to train</text>

  //     {/* <!-- Arrows --> */}
  //     <line x1="320" y1="230" x2="380" y2="230" stroke="#999" strokeWidth="2" markerEnd="url(#arrow)" />
  //     <line x1="620" y1="230" x2="680" y2="230" stroke="#999" strokeWidth="2" markerEnd="url(#arrow)" />

  //     <defs>
  //       <marker id="arrow" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto" markerUnits="strokeWidth">
  //         <path d="M0,0 L0,10 L10,5 z" fill="#555" />
  //       </marker>
  //     </defs>
  //   </svg>
  // </div>
);

export default ReminderSystemFlowchart;
